import React from 'react';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';
import PromoBannerMobile from '@wix/da-ds/pkg/PromoBannerMobile';
import Countdown from '@wix/da-ds/pkg/Time/Countdown';
import { formatDollars } from '../../../utils/formatting';
import { getHasOffers, getIsBeforeOfferEndTime } from '../../../utils/adoptables';
import s from './OfferBannerMobile.scss';
const OfferBannerMobile = ({ className, minOffer, numOffers, highestOffer, offerEndTime, ownOffer, deviation })=>{
    const { t } = useTranslation();
    const hasOffers = !!numOffers;
    const noOffers = !numOffers;
    const ownOfferDollarPrice = ownOffer === null || ownOffer === void 0 ? void 0 : ownOffer.dollarPrice;
    if (!(getHasOffers(deviation) || getIsBeforeOfferEndTime(deviation))) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(PromoBannerMobile, {
        className: className,
        variant: "adoptables",
        message: /*#__PURE__*/ React.createElement("div", {
            className: s['message']
        }, noOffers && /*#__PURE__*/ React.createElement("span", null, t('offerBanner.startingPrice.mobile', {
            postProcess: [
                'reactPostprocessor',
                'featureBrancher'
            ],
            price: /*#__PURE__*/ React.createElement("b", null, formatDollars(minOffer))
        })), hasOffers && /*#__PURE__*/ React.createElement(React.Fragment, null, !!offerEndTime && /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement(Countdown, {
            className: s['countdown'],
            prefix: t('offerBanner.endsCountdown.mobile'),
            countToDate: offerEndTime,
            endedMessage: t('offerBanner.saleEnded'),
            endedClassName: s['countdown-ended'],
            // Matching the countdown we have in adoptables
            renderTimer: (d, h, m, sec)=>/*#__PURE__*/ React.createElement("span", {
                    className: s['countdown-value']
                }, [
                    h + d * 24,
                    m,
                    sec
                ].map((n)=>numeral(n).format('00')).join(':'))
        })), /*#__PURE__*/ React.createElement("span", null, t('offerBanner.highestOffer.mobile', {
            postProcess: [
                'reactPostprocessor',
                'featureBrancher'
            ],
            price: /*#__PURE__*/ React.createElement("b", null, formatDollars(highestOffer))
        })), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("span", {
            className: s['num-offers']
        }, t('offerBanner.numOffers.mobile', {
            postProcess: [
                'reactPostprocessor',
                'featureBrancher'
            ],
            offers: /*#__PURE__*/ React.createElement("b", null, `${numOffers}`)
        })), !!ownOfferDollarPrice && /*#__PURE__*/ React.createElement("span", null, t('offerBanner.myOffer.mobile', {
            postProcess: [
                'reactPostprocessor',
                'featureBrancher'
            ],
            price: /*#__PURE__*/ React.createElement("b", null, formatDollars(ownOfferDollarPrice))
        }))))
    });
};
OfferBannerMobile.displayName = 'OfferBannerMobile';
export default OfferBannerMobile;
